import Vue from 'vue';
const I18nStore = Vue.extend({
    data() {
        return {
            language: '',
            langMaps: {}
        };
    }
});
export const i18nConfigStore = new I18nStore();
